// @flow

import { ACTIONS } from './constants';

const openCalendarMessagingSummaryDrawer = (
    programWorkoutId: number,
    teamId: number,
    title: string,
    date: string,
    athleteId: number | null
) => (dispatch: Function) => {
    return dispatch({
        type: ACTIONS.OPEN_SUMMARY_DRAWER,
        programWorkoutId,
        teamId,
        title,
        date,
        athleteId
    });
};

export default openCalendarMessagingSummaryDrawer;
